/* SLIDE 29 */
/* SLIDE 30 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import searchIcon from "assets/icons/searchIcon.svg";
import arrowDownIcon from "assets/icons/arrowDownIcon.svg";
import SearchBar from "shared/components/SearchBar";
const ScheduleManagementPage = () => {
  const navigate = useNavigate();
  const data = [
    {
      userGroup: "관리자",
      userId: "example01",
      userName: "홍길동",
      registrationDate: "2024.10.16",
    },
    {
      userGroup: "관리자",
      userId: "example02",
      userName: "이길동",
      registrationDate: "2024.06.26",
    },
    {
      userGroup: "관리자",
      userId: "example03",
      userName: "최길동",
      registrationDate: "2024.06.17",
    },
  ];
  const [selectedOption, setSelectedOption] = useState("사용자정보(01-002)");

  const options = [
    "사용자정보(01-002)",
    "사용자정보(01-001)",
    "사용자정보(01-003)",
  ];

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleRowClick = () => {
    navigate("/schedule_setting");
  };
  return (
    <div className="schedule-management-container">
      <SearchBar className=""/>
      <div className="htContent">

        <div className="table-header">
          <select
            className="table-select"
            value={selectedOption}
            onChange={handleChange}
          >
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div className="data-table">
          <div className="table-labels " style={{height: "38px"}}>
            <span>사용자구분</span>
            <span>사용자ID</span>
            <span>사용자명</span>
            <span>등록일자</span>
          </div>
          <div className="table-labels-rows">
            {data.map((row, index) => (
              <div className="filter-table" key={index} onClick={handleRowClick}>
                <span>{row.userGroup}</span>
                <span>{row.userId}</span>
                <span>{row.userName}</span>
                <span>{row.registrationDate}</span>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default ScheduleManagementPage;
